import { defineComponent as _defineComponent } from 'vue'
import { inject, ref } from "vue";
import router from "@/router";
import { Form } from "vee-validate";
import { useUserStore } from "@/stores/userStore";
import validatePhoneNum from "@/views/signup/validatePhoneNum";
import useUnformattingPhoneNumber from "@/use/useUnformattingPhoneNumber";
import TextInput from "@/components/shared/inputs/TextInput.vue";
import BaseButton from "@/components/shared/button/base/BaseButton.vue";
import Modal from "@/components/shared/modal/base/Modal.vue";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";


const __default__ = {
  name: "FindLoginPassword",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const userStore = useUserStore();

const userId = ref("");

const { phoneNumber, onChangePhoneNumber } = validatePhoneNum();
const phoneNumberErrorMessage = ref("");
const findPasswordSuccess = ref(false);

const schema = {
  id: "required:사원번호를",
  phone: "required:휴대폰 번호를|phone",
};

const goToLoginPage = () => {
  findPasswordSuccess.value = false;
  router.currentRoute.value.meta.willGoBack = true;
  router.back();
};

const onSubmit = async () => {
  const findPasswordResult = await userStore.findPassword(
    useUnformattingPhoneNumber(phoneNumber.value),
    userId.value
  );
  if (findPasswordResult.isSuccess) {
    findPasswordSuccess.value = true;
    return;
  }
  if (findPasswordResult.resultCode === 404000102) {
    phoneNumberErrorMessage.value = "입력하신 정보와 일치하는 계정이 없습니다.";
    return;
  }
  showErrorModal(
    "비밀번호 찾기 오류",
    findPasswordResult.errorMessage,
    findPasswordResult.resultCode,
    findPasswordResult.errorTime
  );
};

const resetErrorMessage = () => {
  phoneNumberErrorMessage.value = "";
};

const __returned__ = { showErrorModal, userStore, userId, phoneNumber, onChangePhoneNumber, phoneNumberErrorMessage, findPasswordSuccess, schema, goToLoginPage, onSubmit, resetErrorMessage, get Form() { return Form }, TextInput, BaseButton, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})